import { ModalContext, UseModalContext } from '@prometheus/hooks';
import { getUUID } from '@prometheus/utils';
import React, { FC, useContext, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { VaultList } from './VaultList';

export const Vaults: FC<{ root: any }> = ({ root }) => {
  const { openModal, closeModal } = useContext<UseModalContext>(ModalContext);
  const [isReload, setIdReload] = useState(getUUID());

  return (
    <>
      <Routes>
        <Route path="*" element={<VaultList root={root} />} />
        {/* <Route
            path=":id/*"
            element={<DatabaseEntity onPublish={onPublish} root={root} />}
          /> */}
      </Routes>
    </>
  );
};
